export interface PublicConfig {
  fb_pixel_id: string | null;
  ga_id: string | null;
  google_maps_api_key: string | null;
}

interface PublicConfigEnvelope {
  data?: Partial<PublicConfig> | null;
}

const nullableString = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  const normalized = value.trim();
  return normalized === '' ? null : normalized;
};

let configPromise: Promise<PublicConfig> | null = null;

export function getPublicConfig(): Promise<PublicConfig> {
  if (!configPromise) {
    configPromise = fetch('/api/public-config.php', { credentials: 'include' })
      .then(async (response) => {
        if (!response.ok) throw new Error(`Public config HTTP ${response.status}`);
        const body = await response.json() as PublicConfigEnvelope & Partial<PublicConfig>;
        const data = body.data ?? body;

        return {
          fb_pixel_id: nullableString(data.fb_pixel_id),
          ga_id: nullableString(data.ga_id),
          google_maps_api_key: nullableString(data.google_maps_api_key),
        };
      })
      .catch((error) => {
        configPromise = null;
        throw error;
      });
  }
  return configPromise;
}
